import { Pipe, PipeTransform } from '@angular/core';
import NP from 'number-precision'
import { notNullUndefined } from 'src/app/helpers/utils';

@Pipe({
  name: 'convertSecToHrs'
})
export class ConvertSecToHrsPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    const a =  notNullUndefined(value)? (NP.divide(value,3600)).toFixed(2).toString():'N/A'
    return a
  }

}
